<form [formGroup]="form" (ngSubmit)="onSwitch($event)" class="user-info">
<div class="d-flex align-items-start justify-content-between fon-edit">
    
        <div class="block-select d-flex flex-column align-items-start">
            <div class="block-select-label d-flex">
                <span>{{ 'playerForm.txtQuests' | translate }}</span>
            </div>
            <ng-scrollbar class="settings-scroll">
                <div class="lists-rq d-flex flex-column gap-2">
                @if(isQuest){
                    @for (quest of quests.quests; track quest.rq_id) {
                        @if(availableRQs().includes(quest.rq_id)){
                            @if(quest.rq_id === form.get('selectQuest')?.value){
                                <div class="item-rq selected d-flex justify-content-start align-items-center">
                                    <div class="block-icons">
                                        @if(quest.icons){
                                            @for (item of quest.icons; track $index) {
                                                <span class="material-symbols-outlined">{{item}}</span>
                                            }
                                        }@else{
                                            <span class="material-symbols-outlined">{{quest.icon}}</span>
                                            
                                            <!--<span class="material-symbols-outlined">quiz</span> -->
                                        }
                                    </div>
                                    <div class="liner"></div>
                                    <div class="info-rq">
                                        <span class="title-rq">{{ quest.data.humman_description.title }}</span>
                                        <span class="description-rq">{{ quest.data.humman_description.goal }}</span>
                                    </div>
                                </div>
                            }@else {
                                <div class="item-rq d-flex justify-content-start align-items-center" (click)="selectQuest(quest.rq_id)">
                                    <div class="block-icons">
                                        @if(quest.icons){
                                            @for (item of quest.icons; track $index) {
                                                <span class="material-symbols-outlined">{{item}}</span>
                                            }
                                        }@else{
                                            <span class="material-symbols-outlined">{{quest.icon}}</span>
                                            
                                            <!--<span class="material-symbols-outlined">quiz</span> -->
                                        }
                                    </div>
                                    <div class="liner"></div>
                                    <div class="info-rq">
                                        <span class="title-rq">{{ quest.data.humman_description.title }}</span>
                                        <span class="description-rq">{{ quest.data.humman_description.goal }}</span>
                                    </div>
                                </div>
                            }
                            
                        }
                    }
                }
                
                @if(isRole){
                    @for (quest of roles.roles; track quest.rq_id) {
                        @if(availableRQs().includes(quest.rq_id)){
                            @if(quest.rq_id === form.get('selectRole')?.value){
                                <div class="item-rq selected d-flex justify-content-start align-items-center">
                                    <div class="block-icons">
                                        @if(quest.icons){
                                            @for (item of quest.icons; track $index) {
                                                <span class="material-symbols-outlined">{{item}}</span>
                                            }
                                        }@else{
                                            <span class="material-symbols-outlined">{{quest.icon}}</span>
                                            
                                            <!--<span class="material-symbols-outlined">quiz</span> -->
                                        }
                                    </div>
                                    <div class="liner"></div>
                                    <div class="info-rq">
                                        <span class="title-rq">{{ quest.data.humman_description.title }}</span>
                                        <span class="description-rq">{{ quest.data.humman_description.goal }}</span>
                                    </div>
                                </div>
                            }@else {
                                <div class="item-rq d-flex justify-content-start align-items-center" (click)="selectRole(quest.rq_id)">
                                    <div class="block-icons">
                                        @if(quest.icons){
                                            @for (item of quest.icons; track $index) {
                                                <span class="material-symbols-outlined">{{item}}</span>
                                            }
                                        }@else{
                                            <span class="material-symbols-outlined">{{quest.icon}}</span>
                                            
                                            <!--<span class="material-symbols-outlined">quiz</span> -->
                                        }
                                    </div>
                                    <div class="liner"></div>
                                    <div class="info-rq">
                                        <span class="title-rq">{{ quest.data.humman_description.title }}</span>
                                        <span class="description-rq">{{ quest.data.humman_description.goal }}</span>
                                    </div>
                                </div>
                            }
                            
                        }
                    }
                }
                
            </div>
            </ng-scrollbar>
            
            <div class="mobile-block">
                <mat-form-field appearance="outline" style="width: 100%;" class="mobile-select-rq">
                    @if(isQuest){
                    <mat-select required formControlName="selectQuest"  panelClass="example-panel-form" class="mobile-select-rq">
                        <mat-select-trigger>
                            {{selectedValue || ''}}
                        </mat-select-trigger>                        
                            @for (quest of quests.quests; track quest.rq_id) {
                                @if(availableRQs().includes(quest.rq_id)){
                                    <mat-option  [value]="quest.rq_id" (click)="selectQuest(quest.rq_id)">
                                        <div class="item-rq d-flex justify-content-start align-items-center">
                                            <div class="block-icons">
                                                @if(quest.icons){
                                                    @for (item of quest.icons; track $index) {
                                                        <span class="material-symbols-outlined">{{item}}</span>
                                                    }
                                                }@else{
                                                    <span class="material-symbols-outlined">{{quest.icon}}</span>
                                                    
                                                    <!--<span class="material-symbols-outlined">quiz</span> -->
                                                }
                                            </div>
                                            <div class="liner"></div>
                                            <div class="info-rq">
                                                <span class="title-rq">{{ quest.data.humman_description.title }}</span>
                                                <span class="description-rq">{{ quest.data.humman_description.goal }}</span>
                                            </div>
                                        </div>
                                    </mat-option>
                                    @if(quest.rq_id === form.get('selectQuest')?.value){
                                        <mat-option style="min-height: 2px;pointer-events: none;" disabled>
                                            <div class="isLine"></div>
                                        </mat-option>
                                    }
                                }                            
                            }
                        

                    </mat-select>
                    }
                    @if(isRole){
                    <mat-select required formControlName="selectRole"  panelClass="example-panel-form" class="mobile-select-rq">
                        <mat-select-trigger>
                            {{selectedValue || ''}}
                        </mat-select-trigger>
                        
                        
                            @for (quest of roles.roles; track quest.rq_id) {
                                @if(availableRQs().includes(quest.rq_id)){
                                    <mat-option  [value]="quest.rq_id" (click)="selectRole(quest.rq_id)">
                                        <div class="item-rq d-flex justify-content-start align-items-center">
                                            <div class="block-icons">
                                                @if(quest.icons){
                                                    @for (item of quest.icons; track $index) {
                                                        <span class="material-symbols-outlined">{{item}}</span>
                                                    }
                                                }@else{
                                                    <span class="material-symbols-outlined">{{quest.icon}}</span>
                                                    
                                                    <!--<span class="material-symbols-outlined">quiz</span> -->
                                                }
                                            </div>
                                            <div class="liner"></div>
                                            <div class="info-rq">
                                                <span class="title-rq">{{ quest.data.humman_description.title }}</span>
                                                <span class="description-rq">{{ quest.data.humman_description.goal }}</span>
                                            </div>
                                        </div>
                                    </mat-option>
                                    @if(quest.rq_id === form.get('selectRole')?.value){
                                        <mat-option style="min-height: 2px;pointer-events: none;" disabled>
                                            <div class="isLine"></div>
                                        </mat-option>
                                    }
                                }                            
                            }
                    </mat-select>
                    }
                </mat-form-field>
            </div>
            <div class="rectangle"></div>
        </div>
        <div class="data-player align-items-start d-flex flex-column">
            <div class="player-label">
                <span>{{ 'playerForm.txtFildName' | translate }}</span>
            </div>
            <div class="player-name">
                <mat-form-field class="example-full-width" appearance="outline" style="width: 100%;">
                    <input type="email" matInput placeholder="{{ 'playerForm.txtFildName' | translate }}" formControlName="userName">
                </mat-form-field>
            </div>
            @if(isCardKits()){
                <div class="d-flex align-items-center justify-content-between w-100 block-gender-kits" >
                    <div class="d-flex flex-column g-11">
                        <div class="player-label d-flex">
                            <span>{{ 'playerForm.txtGender' | translate }}</span>
                        </div>
                        <div class="gender-select d-flex align-items-center justify-content-between">
                            @for (gender of genders.genders; track gender.gender_id) {
                                @if(gender.gender_id === form.get('selectedGender')?.value){
                                    <div class="item-gender selected d-flex align-items-center justify-content-center w-100">
                                        <span>{{ gender.name }}</span>
                                    </div>
                                }@else {
                                    <div class="item-gender d-flex align-items-center justify-content-center w-100" (click)="changeGender(gender.gender_id)">
                                        <span>{{ gender.name }}</span>
                                    </div>
                                }
                            }
                        </div>
                    </div>
                    <div class="d-flex flex-column g-11">
                        <div class="player-label d-flex">
                            <span>{{ 'playerForm.txtKits' | translate }}</span>
                        </div>
                        <div class="d-flex align-items-center justify-content-end block-selected-kits">
                            <mat-form-field appearance="outline" style="width: 100%;" class="select-card-kits mobile-select-rq">
                                <mat-select panelClass="panel-form-kits" class="select-card-kits mobile-select-rq" formControlName="selectedKit">
                                    <mat-select-trigger>
                                        {{selectedKitValue || ''}}
                                    </mat-select-trigger>                        
                                        @for (kit of listKits; track kit.card_kit_id) {
                                                <mat-option  [value]="kit.card_kit_id" (click)="selectKit(kit.card_kit_id)">
                                                    <div class="item-kit d-flex justify-content-start align-items-center">
                                                        <div class="block-icons d-flex justify-content-center align-items-center">
                                                            @if(kit?.icons){
                                                                @for (item of kit?.icons; track $index) {
                                                                    <span class="material-symbols-outlined">{{item}}</span>
                                                                }
                                                            }@else{
                                                                <span class="material-symbols-outlined" [style]="{'color': kit?.color }">{{kit?.icon}}</span>
                                                            }
                                                        </div>
                                                        <div class="liner"></div>
                                                        <div class="info-kit">
                                                            <span class="title-kit">{{ kit.data.humman_description.title }}</span>
                                                        </div>
                                                    </div>
                                                </mat-option>
                                
                                        }
                                    

                                </mat-select>                        
                            </mat-form-field>
                        </div>
                    </div>
                    
                </div>
            }@else{
                <div class="player-label d-flex">
                    <span>{{ 'playerForm.txtGender' | translate }}</span>
                </div>
                <div class="gender-select d-flex align-items-center justify-content-between">
                    @for (gender of genders.genders; track gender.gender_id) {
                        @if(gender.gender_id === form.get('selectedGender')?.value){
                            <div class="item-gender selected d-flex align-items-center justify-content-center w-100">
                                <span>{{ gender.name }}</span>
                            </div>
                        }@else {
                            <div class="item-gender d-flex align-items-center justify-content-center w-100" (click)="changeGender(gender.gender_id)">
                                <span>{{ gender.name }}</span>
                            </div>
                        }
                    }
                </div>
            }
            
            @if(player().is_starter){
                <div class="player-label d-flex align-items-center justify-content-between w-100">
                    <span>{{ 'playerForm.txtLevel' | translate }}</span>
                    <span class="material-symbols-outlined icon-mattooltip" appClickableTooltip  matTooltip="{{'playerForm.txtInfoLevel' | translate}}">info</span>
                </div>
                <div class="gender-select d-flex align-items-center justify-content-between">
                    @for (level of listLevels; track level.val) {
                        @if(level.val === form.get('selectLevel')?.value){
                            <div class="item-gender selected d-flex align-items-center justify-content-center w-100" >
                                @if(level.completed){
                                    <span class="material-symbols-outlined">check</span>
                                }
                                <span>{{level.val}}</span>
                            </div>
                        }@else {
                            @if(level.disabled){
                                <div class="item-gender disabled d-flex align-items-center justify-content-center w-100" >
                                    <span>{{level.val}}</span>
                                </div>                         
                            }@else {
                                <div class="item-gender d-flex align-items-center justify-content-center w-100" (click)="changeLevel(level.val)" >
                                    @if(level.completed){
                                        <span class="material-symbols-outlined">check</span>
                                    }
                                    <span>{{level.val}}</span>
                                </div>
                            }
                        }
                    }
                    
                </div>
            }
            <div class="additional-contents d-flex align-items-center justify-content-between w-100">
                <div class="additional-features w-100 d-flex flex-column align-items-start justify-content-between ">
                    <app-training-mode></app-training-mode>
                    <div>
                        <mat-checkbox formControlName="isNewbie" (change)="setAll($event.checked)">{{ 'status.txtNewbie' | translate }}</mat-checkbox><br/>
                        <span class="form-text-features">[{{ 'playerForm.txtInfoNubie' | translate }}]</span>
                    </div>
                    @if(this.configuration.configuration?.config?.i_am_tutor){
                        <div>
                            <mat-checkbox class="example-margin" [formControl]="checkedMentor" (change)="update($event.checked)">{{ 'stenOne.txtMentor' | translate }}</mat-checkbox><br/>
                            <span class="form-text-features">[{{ 'playerForm.txtInfoMentor' | translate }}]</span>
                        </div>
                    }@else {
                        <div class="tmp-mentop d-flex flex-column align-items-start justify-content-between w-100">
                            <div class="d-flex align-items-center justify-content-between w-100">
                                <div class="mentor-block d-flex align-items-center justify-content-start">
                                    <span class="material-symbols-outlined">lock</span>
                                    <span class="text">{{ 'stenOne.txtMentor' | translate }}</span>
                                </div>
                                <a  (click)="showTariffs()" class="d-flex align-items-center justify-content-end" style="cursor: pointer;"  rel="noopener noreferrer" [innerHTML]="'playerForm.txtTariffs' | translate"></a>
                            </div>
                            <span class="form-text-features">[{{ 'playerForm.txtInfoMentor' | translate }}]</span>
                        </div>
                    } 
                </div>
                <div class="lines"></div>
                <div class="infomation-rq d-flex flex-column justify-content-between align-items-start w-100">
                    <div class="block-these">
                        <div class="title">
                            <span>{{ 'targets.txtTilte' | translate }}</span>
                        </div>
                        <div class="description">
                            <span>{{ goal() }}</span>
                        </div>
                    </div>
                    <div class="block-these-descr">
                        <div class="title d-flex justify-content-between align-items-center w-100">
                            <span>{{ 'targets.txtDescription' | translate }}</span>
                            <span class="d-flex align-items-center justify-content-start block-these-descr-button" [class]="fnIsView()" (click)="showText()" >
                                <span>{{ 'playerForm.txtViewFull' | translate }}</span>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.45 9L6 5.55L7.05 4.5L11.55 9L7.05 13.5L6 12.45L9.45 9Z" fill="black" fill-opacity="0.2"/>
                                </svg>
                            </span>
                        </div>
                        <div class="description" [innerHTML]="goalDescr()"></div>
                    </div>
                </div>
            </div>
        </div>
    
</div>

<div class="d-flex justify-content-between align-items-center px-625 my-23125">
    <div class="d-flex justify-content-start align-items-center w-100 mobile-step-1">
        <div class="d-flex justify-content-start align-items-center left-complex-button" (click)="windowExitGame($event)" [attr.data-exit]="isExitGame">
            <button type="button" class="example-icon d-flex justify-content-center align-items-center" >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.33341 15.8332L4.16675 14.6665L8.83342 9.99984L4.16675 5.33317L5.33341 4.1665L10.0001 8.83317L14.6667 4.1665L15.8334 5.33317L11.1667 9.99984L15.8334 14.6665L14.6667 15.8332L10.0001 11.1665L5.33341 15.8332Z" fill="#262626"/>
                </svg>
            </button>
            <span class="sub-button-title">{{ 'buttons.txtCancel' | translate }}</span>
        </div>
        
    </div>
    <div class="d-flex justify-content-center align-items-center w-100 mobile-step-2">
        
        @if(isGoToFinish()){
            <button class="d-flex justify-content-center align-items-center gap-2 btn-next" [disabled]="!form.valid" type="submit">
                <span>{{ 'buttons.txtSave' | translate }}</span>
            </button>
            }@else{
                <button class="d-flex justify-content-center align-items-center gap-2 btn-next" disabled="true">
                    <span>{{ 'buttons.txtSaving' | translate }}</span>
                    <span class="material-symbols-outlined">progress_activity</span>
                </button>
            }
    </div>
    <div class="d-flex justify-content-end align-items-center w-100 mobile-step-3"></div>
</div>

</form>
